import { IWebTableInputs } from './WebTable';

export const webTableTransformer = (node): IWebTableInputs => {
    if (!node) return;
    return {
        title: node.field_header,
        isDark: node.field_dark_mode,
        description: node.field_table_description?.value,
        tableContent: node.field_table_content?.value,
        highlightedRow: node.field_highlighted_row,
        highlightedCol: node.field_highlighted_column
            ? parseInt(node.field_highlighted_column.slice(0), 10)
            : null,
        tableImages: node.relationships?.field_table_image?.flatMap((image) => {
            if (!image.relationships?.field_image) return [];
            return [
                {
                    isLarge: image.field_image_large,
                    name: image.relationships?.field_image?.relationships
                        ?.field_media_image?.relationships?.media__image?.[0]
                        .name,
                    src: image.relationships?.field_image?.relationships
                        ?.field_media_image?.uri?.url,
                    alt: image.relationships.field_image.field_media_image.alt,
                },
            ];
        }),
        ctaLink: node.web_table_link
            ? {
                  text: node.web_table_link?.title,
                  url: node.web_table_link?.uri,
              }
            : null,
    };
};
